var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08364 31.1331H27.6885C29.6242 31.1331 31.1975 29.5802 31.1975 27.6697V6.8899C31.1975 4.97938 29.6242 3.42676 27.6885 3.42676H4.08364C2.14799 3.42676 0.574707 4.97938 0.574707 6.8899V27.6697C0.574707 29.5802 2.14799 31.1331 4.08364 31.1331ZM2.4886 6.88961C2.4886 6.02186 3.20445 5.31553 4.08362 5.31553H27.6885C28.5677 5.31553 29.2835 6.02186 29.2835 6.88961V27.6694C29.2835 28.5371 28.5677 29.2437 27.6885 29.2437H4.08362C3.20445 29.2437 2.4886 28.5371 2.4886 27.6694V6.88961Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2405 12.176H1.53167C1.00342 12.176 0.574707 11.8494 0.574707 11.4469C0.574707 11.0444 1.00342 10.7178 1.53167 10.7178H30.2405C30.7687 10.7178 31.1975 11.0444 31.1975 11.4469C31.1975 11.8494 30.7687 12.176 30.2405 12.176Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59484 7.80187C8.19236 7.80187 7.86572 7.39357 7.86572 6.89048V1.42213C7.86572 0.919044 8.19236 0.510742 8.59484 0.510742C8.99731 0.510742 9.32395 0.919044 9.32395 1.42213V6.89048C9.32395 7.39357 8.99731 7.80187 8.59484 7.80187Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1769 7.80187C22.7744 7.80187 22.4478 7.39357 22.4478 6.89048V1.42213C22.4478 0.919044 22.7744 0.510742 23.1769 0.510742C23.5793 0.510742 23.906 0.919044 23.906 1.42213V6.89048C23.906 7.39357 23.5793 7.80187 23.1769 7.80187Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.89453,
    y1: 17.0322,
    x2: 11.2137,
    y2: 17.0322,
    stroke: "#0071C2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3413,
    y1: 17.0322,
    x2: 18.6605,
    y2: 17.0322,
    stroke: "#0071C2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7881,
    y1: 17.0322,
    x2: 26.1072,
    y2: 17.0322,
    stroke: "#0071C2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.89453,
    y1: 20.2236,
    x2: 11.2137,
    y2: 20.2236,
    stroke: "#0071C2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3413,
    y1: 20.2236,
    x2: 18.6605,
    y2: 20.2236,
    stroke: "#0071C2"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7881,
    y1: 20.2236,
    x2: 26.1072,
    y2: 20.2236,
    stroke: "#0071C2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5.89453,
    y1: 23.415,
    x2: 11.2137,
    y2: 23.415,
    stroke: "#0071C2"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3413,
    y1: 23.415,
    x2: 18.6605,
    y2: 23.415,
    stroke: "#0071C2"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7881,
    y1: 23.415,
    x2: 26.1072,
    y2: 23.415,
    stroke: "#0071C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.fc4248d231cf7a7977e30f2b066ba159.svg";
export { ForwardRef as ReactComponent };